import { render, staticRenderFns } from "./ProofsTopNav.vue?vue&type=template&id=9345b5aa&scoped=true"
import script from "./ProofsTopNav.vue?vue&type=script&lang=js"
export * from "./ProofsTopNav.vue?vue&type=script&lang=js"
import style0 from "./ProofsTopNav.vue?vue&type=style&index=0&id=9345b5aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9345b5aa",
  null
  
)

export default component.exports